'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@workspace/ui/lib';
import { createContext, useContext } from 'react';
import type * as React from 'react';

/** When false, popovers and selects rendered inside the provider keep the side they open on. */
const AvoidCollisionsContext = createContext(true);

function Popover({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  avoidCollisions,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  const contextAvoidCollisions = useContext(AvoidCollisionsContext);

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        onOpenAutoFocus={(e) => e.preventDefault()}
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        avoidCollisions={avoidCollisions ?? contextAvoidCollisions}
        className={cn(
          'text-grey-700 border-grey-100 dark:border-grey-800 z-[999] flex min-w-(--radix-popover-trigger-width) origin-(--radix-popover-content-transform-origin) flex-col gap-6 rounded-[20px] border bg-neutral-100 p-6 dark:shadow-none',
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          'shadow-[0px_429px_120px_0px_rgba(42,43,65,0.00),0px_17px_38px_0px_rgba(42,43,65,0.05)]',
          'dark:bg-grey-1000 dark:text-grey-200',
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}

function PopoverAnchor({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { AvoidCollisionsContext, Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
